interface ConfigType {
    ZBDSERVICEURL: string;
    PDFWORKER_SRC: string;
    COMPOSERURL: string;
    KEYCLOAKCONFIGURL: string;
    API_KEY: string;
    MAX_ATTACHMENT_COUNT: string;
    MAX_ATTACHMENT_LENGTH: string;
    FLAGS: string[];
}

interface VersionType {
    BUILD_VERSION: string;
}

export var config: ConfigType = (window as any).config;
export var version: VersionType = (window as any).version;
